var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_453_2728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_453_2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4751 12.5L7.12511 5.15C6.87511 4.9 6.75428 4.60417 6.76261 4.2625C6.77094 3.92083 6.90011 3.625 7.15011 3.375C7.40011 3.125 7.69594 3 8.03761 3C8.37928 3 8.67511 3.125 8.92511 3.375L16.6001 11.075C16.8001 11.275 16.9501 11.5 17.0501 11.75C17.1501 12 17.2001 12.25 17.2001 12.5C17.2001 12.75 17.1501 13 17.0501 13.25C16.9501 13.5 16.8001 13.725 16.6001 13.925L8.90011 21.625C8.65011 21.875 8.35844 21.9958 8.02511 21.9875C7.69178 21.9792 7.40011 21.85 7.15011 21.6C6.90011 21.35 6.77511 21.0542 6.77511 20.7125C6.77511 20.3708 6.90011 20.075 7.15011 19.825L14.4751 12.5Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret_right.6b3394bc12b30f06c77017658d530900.svg";
export { ForwardRef as ReactComponent };